import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20atmospheric%20abstract%20background%20with%20soft%20golden%20and%20coral%20gradients%2C%20dreamy%20editorial%20style%2C%20ethereal%20light%20leaks%2C%20gentle%20texture%2C%20warm%20and%20inviting%20tone&width=1800&height=900&seq=cta-bg-home&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />

      <div className="relative z-10 w-full max-w-3xl mx-auto px-6 flex flex-col items-center text-center py-20">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight tracking-wide">
          不错过任何一个瓜
        </h2>
        <p className="mt-4 text-base md:text-lg text-background-50/80 max-w-lg leading-relaxed">
          订阅吃瓜网黑料，第一时间获取网红塌房快讯<br />与国产精品爆料合集
        </p>
        <Link
          to="/category/chigua-kuaixun"
          className="group mt-8 inline-flex items-center gap-3 px-8 py-4 rounded-full bg-background-50 text-foreground-950 text-sm font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          <span className="flex items-center justify-center w-6 h-6 rounded-full bg-accent-500">
            <i className="ri-flashlight-line text-background-50 text-xs w-4 h-4 flex items-center justify-center" />
          </span>
          立即吃瓜
          <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center" />
        </Link>
      </div>
    </section>
  );
}